import { render } from "./HelpTims.vue?vue&type=template&id=34d729f0&scoped=true"
import script from "./HelpTims.vue?vue&type=script&lang=js"
export * from "./HelpTims.vue?vue&type=script&lang=js"

import "./HelpTims.vue?vue&type=style&index=0&id=34d729f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34d729f0"]])

export default __exports__